import { useState } from "react";
import "./ReviewModal.css";
import api from "../../api/api";

function ReviewModal({ trackId, phaseId, phaseOrder, onComplete }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (rating === 0) return setError("Please select a star rating.");
    
    try {
      setSubmitting(true);
      await api.post("/tracks/review", {
        trackId,
        phaseId,
        phaseOrder,
        rating,
        feedback
      });
      onComplete(); // Move to next step or close
    } catch (err) {
      console.error(err);
      setError("Failed to submit review. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <div className="review-overlay">
      <div className="review-modal">
        <div className="review-header">
            <span className="celebration">✨</span>
            <h2>You've crushed Phase {phaseOrder}!</h2>
            <p>How was your experience during this phase? Your feedback helps us improve.</p>
        </div>

        <div className="rating-section">
          {[...Array(5)].map((star, index) => {
            index += 1;
            return (
              <button
                type="button"
                key={index}
                className={`star-btn ${index <= (hover || rating) ? "on" : "off"}`}
                onClick={() => setRating(index)}
                onMouseEnter={() => setHover(index)}
                onMouseLeave={() => setHover(rating)}
              >
                <span className="star">&#9733;</span>
              </button>
            );
          })}
        </div>

        <div className="feedback-section">
          <textarea
            placeholder="Tell us what you liked or what could be better..."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            disabled={submitting}
          />
        </div>

        {error && <p className="review-error">{error}</p>}

        <div className="review-actions">
          <button 
            className="submit-review-btn" 
            onClick={handleSubmit} 
            disabled={submitting}
          >
            {submitting ? "Sending..." : "Submit Review"}
          </button>
          
          <div className="contribute-callout">
            <p>Want to help others? <span className="link" onClick={() => window.open("/contribute", "_blank")}>Contribute to Learnlia</span></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReviewModal;
